module.exports = {};


//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/$.iterators.js
// module id = 24
// module chunks = 0